var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        id: "storyList-modal",
        title: _vm.editMode
          ? _vm.$t("chatbotv2.updateStory")
          : _vm.$t("chatbotv2.newStory"),
        wrapClassName: "vertical-center-modal",
        visible: _vm.modalVisible,
        okText: _vm.$t("message.ok"),
        cancelText: _vm.$t("message.cancel"),
      },
      on: {
        ok: function ($event) {
          return _vm.handleOk()
        },
        cancel: function ($event) {
          return _vm.handleCancel()
        },
      },
    },
    [
      _c(
        "a-form",
        {
          staticClass: "d-flex flex-column justify-content-center",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.handleSave.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "a-form-item",
            {
              attrs: {
                label: _vm.$t("chatbotv2.storyTitle"),
                fieldDecoratorOptions: {
                  rules: [
                    { required: true, message: "Please input title of story!" },
                  ],
                },
              },
            },
            [
              _c("a-input", {
                class: { "cls-error": _vm.isTitleEmpty },
                model: {
                  value: _vm.form.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "title", $$v)
                  },
                  expression: "form.title",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-item",
            {
              attrs: {
                label: _vm.$t("chatbotv2.storyDescription"),
                fieldDecoratorOptions: {
                  rules: [
                    {
                      required: true,
                      message: "Please input a description for story!",
                    },
                  ],
                },
              },
            },
            [
              _c("a-input", {
                model: {
                  value: _vm.form.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "description", $$v)
                  },
                  expression: "form.description",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }